import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { bapi, fmtDateTime } from '@/lib/billingApi';
import { TestTag } from './shared';

export const AlertsBanner = ({ rows, onResolved }) => {
  if (!rows.length) return null;
  const resolve = (key) => bapi('/admin/billing/alerts/resolve', { method: 'POST', body: { key } })
    .then(() => { toast.success('Alert resolved'); onResolved(); })
    .catch((e) => toast.error(e.message));
  return (
    <div className="rounded-xl border border-red-200 bg-red-50 p-4 space-y-2" data-testid="billing-alerts">
      <p className="text-sm font-bold text-red-800 flex items-center gap-2"><AlertTriangle className="w-4 h-4" />Billing alerts ({rows.length})</p>
      {rows.map((a, i) => (
        <div key={a.key} className="flex items-start justify-between gap-3 bg-white rounded-lg border border-red-100 px-3 py-2" data-testid={`billing-alert-${i}`}>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-slate-900">{a.title}{a.simulated && <TestTag />}</p>
            <p className="text-xs text-slate-600 break-words">{a.message}</p>
            <p className="text-[11px] text-slate-400 mt-0.5">{fmtDateTime(a.at)}</p>
          </div>
          <Button size="sm" variant="outline" className="shrink-0" onClick={() => resolve(a.key)} data-testid={`billing-alert-resolve-${i}`}>Resolve</Button>
        </div>
      ))}
    </div>
  );
};
